import { render } from "./TournamentView.vue?vue&type=template&id=03097952&ts=true"
import script from "./TournamentView.vue?vue&type=script&lang=ts"
export * from "./TournamentView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/Admin/Tournaments/TournamentView.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "03097952"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('03097952', __exports__)) {
    api.reload('03097952', __exports__)
  }
  
  module.hot.accept("./TournamentView.vue?vue&type=template&id=03097952&ts=true", () => {
    api.rerender('03097952', render)
  })

}


export default __exports__